module.exports = {"history":"Work History","improving":"Senior Consultant","improving-duration":"Nov 2017 - Present","aver":"Front-end Engineer","aver-duration":"July 2017 - Nov 2017","capitalone":"Senior Software Engineer","capitalone-duration":"July 2014 - May 2017"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/work.json
// module id = 76
// module chunks = 0